import {createSlice} from "@reduxjs/toolkit";


export type menuState = {
    loading: boolean,
    isBottomMenuOpen: boolean,
    showEdit: boolean,
    activeData: object
}

const initialState: menuState = {
    loading: false,
    isBottomMenuOpen: false,
    showEdit: false,
    activeData: {}
}

const action = {}

const slice = createSlice({
    name: "menu",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload
        },
        setIsBottomMenuOpen(state, {payload}) {
            state.isBottomMenuOpen = payload
        },
        setShowEdit(state, {payload}) {
            state.showEdit = payload
        },
        setActiveData(state, {payload}) {
            state.activeData = payload
        },

    },
    extraReducers: (builder) => {
        builder
    }
})

export const menu = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
}